export const isInternalPM = (medium: string) => medium === 'CPC_PM' || medium === 'CPC-PM' || medium === 'CPC_pm';
export const isWazimo = () => window.location.href.includes('/view?id=');
export const isShinez = () => {
  const params = new URLSearchParams(window.location.search);
  return params.has('art-name') || params.has('art-id');
};
